import {
  DocumentFolderViewColumnItems,
  INewFolder,
} from '@commenda/types/src/drive-view/types';
import { NonTimezoneSensitiveDate } from '@commenda/utils';

export function getColumnItems(
  tree: INewFolder
): DocumentFolderViewColumnItems[] {
  if (!tree) return [];

  let displayItems: DocumentFolderViewColumnItems[] = tree.folders?.map(
    (folder) => {
      const noOfFiles = folder.files.filter(
        (file) => file.id !== null && file.id !== undefined
      );
      return {
        id: folder.id,
        name: folder.name,
        type: 'Folder',
        noOfFiles: noOfFiles.length,
        lastModifiedDate: folder.lastModifiedDate,
      };
    }
  );

  displayItems = [
    ...(displayItems || []),
    ...(tree?.files || [])?.map((file) => ({
      id: file.id,
      name: file.fileName,
      type: 'File' as 'File' | 'Folder',
      documentType: file.documentSubType,
      lastModifiedDate: file.updatedAt
        ? NonTimezoneSensitiveDate.fromNativeDate(
            new Date(file.updatedAt)
          ).toISO8601String()
        : null,
      explicitDocumentType: file.documentSubType,
    })),
  ];

  return displayItems;
}

export const resolveFolderPath = (
  folderLevels: (string | number)[],
  tree: INewFolder
): INewFolder | null => {
  // If there's no more folder levels to look for, return the tree
  if (folderLevels.length === 0) return tree;

  const p = folderLevels.shift();
  // if the current folder level matches the tree Id, return the tree
  if (p === tree.id) return resolveFolderPath(folderLevels, tree);

  // Recursively look for all the folders till you find the matching id
  for (let i = 0; i < tree.folders.length; ) {
    if (tree.folders[i].id === p)
      return resolveFolderPath(folderLevels, tree.folders[i]);
    i += 1;
  }

  return null;
};
